<template>
  <svg width="28"
       height="18"
       viewBox="0 0 28 18"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M26.5508 2.96589L27.2363 2.26277C27.5791 1.90241 27.5967 1.41023 27.2539 1.06745L27.0254 0.830149C26.7178 0.522532 26.208 0.566477 25.874 0.900462L25.1797 1.58601L26.5508 2.96589ZM16.5225 11.9307L18.377 11.1309L25.9092 3.60749L24.5293 2.24519L17.0059 9.76863L16.1709 11.5704C16.083 11.7813 16.3203 12.0186 16.5225 11.9307ZM3.0752 17.8634H21.418C23.0791 17.8634 24.002 16.9581 24.002 15.3057V7.77351L22.2266 9.5489V15.1475C22.2266 15.8331 21.8398 16.2198 21.1455 16.2198H3.33887C2.65332 16.2198 2.2666 15.8331 2.2666 15.1475V7.82624C2.2666 7.13191 2.65332 6.75398 3.33887 6.75398H17.7441L19.3789 5.11921H3.0752C1.41406 5.11921 0.491211 6.0157 0.491211 7.66804V15.3057C0.491211 16.9581 1.41406 17.8634 3.0752 17.8634ZM5.51855 12.8009C6.23926 12.8009 6.81934 12.212 6.81934 11.4913C6.81934 10.7618 6.23926 10.1817 5.51855 10.1817C4.78906 10.1817 4.2002 10.7618 4.2002 11.4913C4.2002 12.212 4.78906 12.8009 5.51855 12.8009ZM9.40332 12.8009C10.124 12.8009 10.7129 12.212 10.7129 11.4913C10.7129 10.7618 10.124 10.1817 9.40332 10.1817C8.67383 10.1817 8.09375 10.7618 8.09375 11.4913C8.09375 12.212 8.67383 12.8009 9.40332 12.8009ZM13.2881 12.8009C14.0088 12.8009 14.5977 12.212 14.5977 11.4913C14.5977 10.7618 14.0088 10.1817 13.2881 10.1817C12.5674 10.1817 11.9785 10.7618 11.9785 11.4913C11.9785 12.212 12.5674 12.8009 13.2881 12.8009Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'ExtradataIcon',
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style>

</style>
